var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"counterRef",staticClass:"number-counter"},[_vm._v(_vm._s(_vm.displayValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }